export default "__VITE_ASSET__C0Vti7SP__"